
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Reveal } from './Reveal';

export const BenefitsSection: React.FC = () => {
  const { t } = useTranslation();

  const benefits = [
    {
      id: "01",
      titleKey: "benefits.items.roi.title",
      descKey: "benefits.items.roi.desc",
      highlightKey: "benefits.items.roi.highlight"
    },
    {
      id: "02",
      titleKey: "benefits.items.sovereignty.title",
      descKey: "benefits.items.sovereignty.desc",
      highlightKey: "benefits.items.sovereignty.highlight"
    },
    {
      id: "03",
      titleKey: "benefits.items.availability.title",
      descKey: "benefits.items.availability.desc",
      highlightKey: "benefits.items.availability.highlight"
    },
    {
      id: "04",
      titleKey: "benefits.items.scaling.title",
      descKey: "benefits.items.scaling.desc",
      highlightKey: "benefits.items.scaling.highlight"
    }
  ];

  return (
    <section className="py-20 md:py-40 bg-white">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header - Matching Branchenkompetenz Style */}
        <Reveal>
          <div className="flex flex-col md:flex-row justify-between items-end mb-16 md:mb-24 border-b border-gray-900 pb-8">
            <h2 className="text-5xl md:text-7xl font-bold text-gray-900 tracking-tighter leading-none">
              {t('benefits.title_line1')}<br />{t('benefits.title_line2')}
            </h2>
            <p className="text-gray-500 max-w-md text-right mt-8 md:mt-0 text-lg">
              {t('benefits.subtitle')}
            </p>
          </div>
        </Reveal>

        {/* Architectural Grid Layout (No Box Shadow, Hard Lines) */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-gray-200">
          {benefits.map((item, idx) => (
            <Reveal key={idx} delay={idx * 0.1}>
              <div className="group p-12 border-b border-r border-gray-200 hover:bg-gray-50 transition-all duration-500 min-h-[300px] flex flex-col justify-between relative overflow-hidden">

                <div className="absolute top-0 right-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <span className="text-clever-teal text-xs font-bold uppercase tracking-widest">{t(item.highlightKey)}</span>
                </div>

                <div className="text-xs font-mono text-gray-400 mb-8">
                  {item.id}
                </div>

                <div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-6 group-hover:translate-x-2 transition-transform duration-300">
                    {t(item.titleKey)}
                  </h3>
                  <p className="text-gray-500 leading-relaxed text-lg max-w-sm">
                    {t(item.descKey)}
                  </p>
                </div>

              </div>
            </Reveal>
          ))}
        </div>

        {/* OPTION 2: The Agnostic Leiste (Footer) */}
        <Reveal delay={0.4}>
          <div className="border-t border-gray-200 mt-0 py-12 text-center">
            <div className="inline-block px-3 py-1 bg-gray-100 text-gray-500 text-[10px] font-mono font-bold uppercase tracking-widest mb-4">
               // SYSTEM AGNOSTIC OPTIMIZATION
            </div>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto font-light">
              {t('benefits.footer')}
            </p>
          </div>
        </Reveal>

      </div>
    </section>
  );
};
